import { Wallet } from "@privy-io/react-auth";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Button } from "@/atoms-react/button/Button.react";
import Loader from "@/atoms-react/loader/Loader.react";
import { Modal, ModalContent } from "@/atoms-react/modal/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { CreateWalletReq, CreateWalletResponse } from "@/features/kypay/types";
import { Themes } from "@/types/theme";

type ConfiirmationWalletPropsType = {
  authenticated?: boolean;
  confirmationPopup?: boolean;
  wallet: Wallet | undefined;
  handleLogoutPrivy: () => void;
  ready: boolean | undefined;
  onClose: () => void;
  isPendingCreationWallet: boolean;
  autoFetchWallet: (numberFetchMax?: number | undefined, count?: number | undefined) => void;
  handleConnectWallet: (requestData: CreateWalletReq) => Promise<CreateWalletResponse>;
};
export const ModalConfirmCreationAddWallet = ({
  wallet,
  authenticated = false,
  confirmationPopup,
  handleLogoutPrivy,
  ready,
  onClose,
  handleConnectWallet,
  autoFetchWallet,
  isPendingCreationWallet = false
}: ConfiirmationWalletPropsType) => {
  const { t } = useTranslation(["wallet"]);

  return (
    <>
      {authenticated && wallet && (
        <Modal
          open={confirmationPopup}
          onClose={async () => {
            onClose();
            await handleLogoutPrivy();
          }}
          maxWidthClassName="max-w-2xl"
        >
          {!ready ? (
            <Loader />
          ) : (
            <ModalContent>
              <Base className="mb-4 p-4 font-semibold text-base">
                {t("kypay.modal_add_wallet.label.confirmation")}
                <span className="text-primary text-sm">{wallet?.address}</span>
              </Base>

              <div className="mt-4 flex flex-row justify-evenly">
                <Button
                  shortcut="enter"
                  theme={Themes.declarative}
                  onClick={async () => {
                    await handleLogoutPrivy();
                    onClose();
                  }}
                >
                  {t("kypay.modal_add_wallet.label.cancel_button")}
                </Button>
                <Button
                  shortcut="enter"
                  className="ml-1 w-1/2 shrink-0"
                  theme={Themes.primary}
                  loading={isPendingCreationWallet}
                  onClick={async () => {
                    let response;
                    try {
                      response = await handleConnectWallet({
                        walletAddress: wallet?.address,
                        wallet_connect: true,
                        olky_wallet: false
                      });
                    } catch (_) {
                      await handleLogoutPrivy();
                      toast.error(t("wallet:kypay.error.create_wallet"));
                    }
                    if (response.success) {
                      toast.success(t("wallet:kypay.success.create_wallet"));
                      autoFetchWallet();
                    } else {
                      await handleLogoutPrivy();
                      toast.error(t("wallet:kypay.error.create_wallet"));
                    }

                    onClose();
                  }}
                >
                  {t("kypay.modal_add_wallet.label.confirmation_button")}
                </Button>
              </div>
            </ModalContent>
          )}
        </Modal>
      )}
    </>
  );
};
